<template>
  <div class="day-trip">
    <form method="post" :action="trip.register_link">
      <input type="hidden" name="tripID" :value="trip.id" />
      <h3>{{ trip.tripTypePageName }}</h3>
      <h4>{{ trip.start_ts }}</h4>
      <p>Class: {{ trip.tripTypePageTripClass }}</p>
      <p>${{ trip.cost }} per person, 10+ ${{ trip.discount_cost }} per person, 25+ please call</p>
      <div class="row" v-if="trip.tripTypePageThumbnail">
        <div class="col-xs-12 col-sm-4">
          <img :src="trip.tripTypePageThumbnail" />
        </div>
        <div class="col-xs-12 col-sm-8">
          {{ trip.tripTypePageDescription }}
        </div>
      </div>
      <div v-else>
        {{ trip.tripTypePageDescription }}
      </div>
      <div v-if="tripFull" class="row">
        <div class="col-xs-12 col-sm-offset-4 col-sm-4">
          <button type="button" @click.prevent="navigateTo(trip.tripTypePageLink)">More Info</button>
        </div>
        <div class="col-xs-12 col-sm-4">
          <span class="big-red">Please Call</span>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-xs-12 col-sm-4">
          <select name="adults" required>
            <option value="">Number of Rafters</option>
            <option v-if="callAdults" value="">Please call for less than {{ callAdults }}</option>
            <option v-for="value in endAdults" v-if="value >= startAdults"  :value="value">{{ value }}</option>
            <option value="">Call For More Spaces</option>
          </select>
        </div>
        <div class="col-xs-12 col-sm-4">
          <button type="submit">Book This Trip</button>
        </div>
        <div class="col-xs-12 col-sm-4">
          <button type="button" @click.prevent="navigateTo(trip.tripTypePageLink)">More Info</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Trip',
  props: [
    'trip'
  ],
  methods: {
    navigateTo: function (nav) {
      window.location=nav
    },
  },
  computed: {
    tripFull: function () {
      return parseInt(this.trip.capacity, 10) == parseInt(this.trip.current_reservations, 10)
    },
    callAdults: function () {
      //if the minimum registrations have not been met, and there is more than one registration left to meet the minimum set the call number and the minimum
      if(parseInt(this.trip.min_reservations, 10) > parseInt(this.trip.current_reservations, 10)){
        if((parseInt(this.trip.min_reservations, 10) - parseInt(this.trip.current_reservations, 10)) > 1){
          return (parseInt(this.trip.min_reservations, 10) - parseInt(this.trip.current_reservations, 10))
        } else {
          return false
        }
      } else {
        return false
      }
    },
    startAdults: function () {
      //if the minimum registrations have not been met, and there is more than one registration left to meet the minimum set the call number and the minimum
      if(parseInt(this.trip.min_reservations, 10) > parseInt(this.trip.current_reservations, 10)){
        if((parseInt(this.trip.min_reservations, 10) - parseInt(this.trip.current_reservations, 10)) > 1){
          return (parseInt(this.trip.min_reservations, 10) - parseInt(this.trip.current_reservations, 10))
        } else {
          return 1
        }
      } else {
        return 1
      }
    },
    endAdults: function () {
      return parseInt(this.trip.capacity, 10) - parseInt(this.trip.current_reservations, 10)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Trip.vue